export default __webpack_public_path__ + "static/media/master-card.7ff24f8b.svg";